import fetch from '@/plugin/axios'

// 新增口令活动
export function getCipherDraw (query) {
  return fetch({
    url: '/api/order/cipher-gift/add',
    method: 'Post',
    data: query
  })
}
// 口令活动列表
export function getCipherList (query) {
  return fetch({
    url: '/api/order/cipher-gift/list',
    method: 'Post',
    data: query
  })
}
// 修改活动列表
export function getCipherUpdate (query, id) {
  return fetch({
    url: `/api/order/cipher-gift/update/${id}`,
    method: 'Post',
    data: query
  })
}
// 详情
export function getCipherInfo (id) {
  return fetch({
    url: `/api/order/cipher-gift/info/${id}`,
    method: 'Get'
  })
}
// 关闭
export function getCipherClose (id) {
  return fetch({
    url: `/api/order/cipher-gift/close/${id}`,
    method: 'Get'
  })
}

export function zipWords (id) {
  return fetch({
    url: `/api/order/cipher-gift/zip/${id}`,
    method: 'Get',
    headers: {
      'Content-Type': 'application/zip'
    },
    responseType: 'blob'
  })
}
// 开启
export function getCipherOpen (id) {
  return fetch({
    url: `/api/order/cipher-gift/open/${id}`,
    method: 'Get'
  })
}
// 领取记录
export function getCipherLog (query) {
  return fetch({
    url: '/api/order/cipher-gift/log',
    method: 'Post',
    data: query
  })
}
